<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      :search.sync="searchForm"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="tempCarBllChangeLogListForm">
        <el-table :data="form.tempCarBllChangeLogList" min-height="250" border style="width: 100%">
          <el-table-column prop="operateTime" label="操作时间" width="180"> </el-table-column>
          <el-table-column prop="operatePerson" label="操作人" width="180"> </el-table-column>
          <el-table-column prop="operateDescription" label="操作信息"> </el-table-column>
        </el-table>
      </template>
      <template slot="spaceNameSearch">
        <selectSearch  v-model="parkingLotId" :dicData="parkingLotList" @change="getOutPassage"></selectSearch>
      </template>
      <template slot="minMoneySearch">
        <div>
          <el-input v-model="minMoney" style="width:6rem;" maxlength="4" type="number"></el-input>
          <span>至</span>
          <el-input v-model="maxMoney" style="width:6rem;" maxlength="4" type="number"></el-input>
        </div>
      </template>

      <template slot="chargeTotalSumSearch">
        <el-input v-model="chargeTotalSum" disabled></el-input>
      </template>
      <template slot="chargeAmountSumSearch">
        <el-input v-model="chargeAmountSum" disabled></el-input>
      </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permissionList.delBtn"
          @click="handleDelete"
          >删 除
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload"
          plain
          v-if="permissionList.exportBtn"
          @click="handleExport"
          >导出
        </el-button>
      </template>
      <template slot="outPassageNameSearch">
        <el-select v-model="searchForm.outPassageName" placeholder="出场通道名称">
          <el-option
            v-for="item in outPassageList"
            :key="item.id"
            :value="item.passageName"
            :label="item.passageName"
          ></el-option>
        </el-select>
      </template>
      <template slot="outPassageNameForm">
        <el-select v-model="form.outPassageName" placeholder="请选择 出场通道名称">
          <el-option
            v-for="item in outPassageList"
            :key="item.id"
            :value="item.passageName"
            :label="item.passageName"
          ></el-option>
        </el-select>
      </template>
      <template slot="updateTimeSearch">
        <div><fastSelectTime ref="updateTimeRange" :times.sync="searchForm.updateTimeRange"></fastSelectTime></div>
      </template>

      <template slot="chargeTotal" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.chargeTotal) }}
      </template>
      <template slot="discountAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.discountAmount) }}
      </template>
      <template slot="chargeAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.chargeAmount) }}
      </template>

      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          v-if="permissionList.payDetailsBtn"
          @click="openTempCarPayDetail(scope.row, 'view')"
          >支付明细
        </el-button>
      </template>
    </avue-crud>
    <tempCarPayDetail
      v-if="tempCarPayDetailVisible"
      :visible.sync="tempCarPayDetailVisible"
      :tempCarBillId="tempCarBillId"
      :spaceId="spaceId"
    ></tempCarPayDetail>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getFreeOpenReason,
} from '@/api/v4ward/carv2/tempcarbill';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { mapGetters } from 'vuex';
import { getToken } from '@/util/auth';
import tempCarPayDetail from './temp-car-pay-detail.vue';
import fastSelectTime from '@/views/v4ward/a-components/fast-select-time.vue';
import { getOutPassage } from '@/api/v4ward/carv2/carinoutinfo.js';
export default {
  components: { tempCarPayDetail, fastSelectTime },
  data() {
    return {
      tempCarBillId: '',
      spaceId: '',
      tempCarPayDetailVisible: false,
      form: {
        updateTimeRange:[this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1,'day'),this.dayjs().format('YYYY-MM-DD 23:59:59')],
        outPassageName: '',
      },
      query: {},
      searchForm: {
        updateTimeRange:[this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1,'day'),this.dayjs().format('YYYY-MM-DD 23:59:59')],
        outPassageName: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      outPassageList: [],
      selectionList: [],
      parkingLotId: '',
      parkingLotList: [],
      chargeTotalSum:'0',
      chargeAmountSum:'0',
      minMoney:'',
      maxMoney:'',
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 24,
        searchLabelWidth: '110',
        menuWidth: 170,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        menu: true,
        columnBtn: true,
        dialogClickModal: false,
        refreshBtn: true,
        stripe: true,
        editBtn: true,
        labelWidth: 110,
        column: [
          {
            label: '车场名称',
            prop: 'spaceName',
            width: 120,
            type: 'select',
            search: true,
            searchslot: true,
            hide: true,
            disabled: true,
            showColumn: false,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
          },

          {
            label: '订单编号',
            search: true,
            prop: 'payNo',
            width: 180,
            disabled: true,
            overHidden: true,
            defaultSort: {
              prop: 'name',
              order: 'descending',
            },
          },
          {
            label: '车牌号',
            search: true,
            disabled: true,
            prop: 'plateNumber',
            width: 90,
          },
          {
            label: '应收金额',
            prop: 'chargeTotal',
            width: 70,
            slot: true,
            rules: [
              {
                required: true,
                message: '请输入应收金额',
                trigger: 'blur',
              },
              {
                trigger: 'change',
                pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/,
                message: '请输入8位以内最多2位小数金额',
              },
            ],
            align: 'right',
          },
          {
            label: '优惠金额',
            prop: 'discountAmount',
            width: 70,
            slot: true,
            maxlength: 11,

            rules: [
              {
                required: true,
                message: '请输入优惠金额',
                trigger: 'blur',
              },
              {
                trigger: 'change',
                pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/,
                message: '请输入8位以内最多2位小数金额',
              },
            ],
            align: 'right',
          },
          {
            label: '实收金额',
            prop: 'chargeAmount',
            width: 70,
            slot: true,
            rules: [
              {
                required: true,
                message: '请输入实收金额',
                trigger: 'blur',
              },
              {
                trigger: 'change',
                pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/,
                message: '请输入8位以内最多2位小数金额',
              },
            ],
            align: 'right',
          },
          {
            label: '出场通道名称',
            search: true,
            prop: 'outPassageName',
            width: 140,
            formslot: true,
            searchslot: true,
          },
          {
            label: '入场时间',
            prop: 'inTime',
            width: 160,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请选择入场时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出场时间',
            prop: 'outTime',
            width: 150,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请选择出场时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '订单时间',
            prop: 'updateTime',
            width: 150,
            hide:true,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            searchSpan: 12,
            search: true,
            searchslot:true,
          },
          {
            label: '停车时长',
            prop: 'stopTime',
            disabled: true,
            display: false,
            width: 130,
          },
          {
            label: '是否付款',
            type: 'select',
            prop: 'payStatus',
            width: 90,
            rules: [
              {
                required: true,
                message: '请选择是否付款',
                trigger: 'change',
              },
            ],
            dicData: [
              {
                label: '未付款',
                value: 0,
              },
              {
                label: '已付款',
                value: 1,
              },
            ],
          },
          {
            label: '付款时间',
            prop: 'payTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '支付方式',
            prop: 'payType',
            type: 'select',
            props: {
              label: 'dictValue',
              value: 'dictValue',
            },
            dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=park_pay_type',
            search: true,
            width: 80,
          },
          {
            label: '车辆分类',
            prop: 'payType2',
            display: false,
            showColumn: false,
            disabled: true,
            width: 80,
          },
          {
            label: '操作人',
            disabled: true,
            prop: 'opeatorName',
            width: 80,
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'select',
            dicData: [],
            display: false,
            props: {
              label: 'openReason',
              value: 'openReason',
            },
            rules: [
              {
                required: true,
                message: '请选择备注',
                trigger: 'blur',
              },
            ],
            overHidden: true,
          },
          {
            label: '是否付款',
            type: 'select',
            prop: 'searchPayStatus',
            searchSpan: 6,
            search: false,
            showColumn: false,
            display: false,
            hide: true,
            dicData: [
              {
                label: '未付款',
                value: 0,
              },
              {
                label: '已付款',
                value: 1,
              },
            ],
          },
          {
            label: '日志信息',
            prop: 'tempCarBllChangeLogList',
            formslot: true,
            row: true,
            showColumn: false,
            span: 24,
            editDisplay: false,
            addDisplay: false,
          },
          {
            label: '应缴金额',
            prop: 'minMoney',
            hide:true,
            search:true,
            searchslot:true,
          },
          {
            label: '最大应缴',
            // search: true,
            hide:true,
            prop: 'maxMoney',
          },
          {
            label: '应缴总额',
            prop: 'chargeTotalSum',
            hide:true,
            search:true,
            searchslot:true,
          },
          {
            label: '实缴总额',
            prop: 'chargeAmountSum',
            hide:true,
            search:true,
            searchslot:true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.tempcarbill_add, false),
        viewBtn: this.vaildData(this.permission.tempcarbill_view, false),
        delBtn: this.vaildData(this.permission.tempcarbill_delete, false),
        editBtn: this.vaildData(this.permission.tempcarbill_edit, false),
        exportBtn: this.vaildData(this.permission.parkblacklist_export, false),
        payDetailsBtn: this.vaildData(this.permission.tempcarbill_pay_details, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {
    'form.payType'(val) {
      console.log(123456);
      console.log(val);
      setTimeout(() => {
        this.$nextTick(() => {
          let remarkColumn = this.findObject(this.option.column, 'remark');
          if (val == '免费开闸') {
            remarkColumn.display = true;
          } else {
            remarkColumn.display = false;
          }
        });
      });
    },
  },
  created() {
    this.option.height = this.bodyHeight - 430;
    getSpaceTree().then((data) => {
      this.parkingLotList = data.data;
      if (data.data.length > 0) {
        this.parkingLotId = this.parkingLotList[0].id;
      }
      this.getOutPassage(this.parkingLotId);
      this.onLoad();
    });
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 430) {
              this.option.height = this.bodyHeight - 280;
            } else {
              this.option.height = this.bodyHeight - 430;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  methods: {
    openTempCarPayDetail(row) {
      this.tempCarBillId = row.id;
      this.spaceId = row.parkingLotId;
      this.tempCarPayDetailVisible = true;
    },
    // 获取出场通道
    getOutPassage(spaceId) {
      getOutPassage({ spaceId: spaceId }).then((res) => {
        this.outPassageList = res.data;
        this.searchForm.outPassageName = '';
      });
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      if (Number(row.chargeTotal) < 0.01) {
        this.$message.error('应收金额不能小于0.01');
        loading();
        return;
      }
      this.outPassageList.forEach((ele) => {
        if (ele.passageName == row.outPassageName) {
          row.outPassageId = ele.id;
        }
      });
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleExport() {
      let parkingLotId = this.query.parkingLotId;
      if (this.vdui.isEmpty(this.query.parkingLotId)) {
        parkingLotId = this.tempParkingLotId;
      }
      let payNo = this.query.payNo || '';
      if (this.vdui.isEmpty(this.query.payNo)) {
        payNo = '';
      }
      let plateNumber = this.query.plateNumber;
      if (this.vdui.isEmpty(this.query.plateNumber)) {
        plateNumber = '';
      }
      let payType = this.query.payType;
      if (this.vdui.isEmpty(this.query.payType)) {
        payType = '';
      }
      let outPassageName = this.query.outPassageName;
      if (this.vdui.isEmpty(this.query.outPassageName)) {
        outPassageName = '';
      }
      let updateTimeStart = "";
      let updateTimeEnd = "";
      if(this.vdui.isNotEmpty(this.query.updateTimeRange)){
        updateTimeStart = this.dayjs(this.query.updateTimeRange[0]).format('YYYY-MM-DD HH:mm:ss');
        updateTimeEnd = this.dayjs(this.query.updateTimeRange[1]).format('YYYY-MM-DD HH:mm:ss');
      }

      window.open(
        `/api/parkTempCarBill/export/v2?${
          this.website.tokenHeader
        }=${getToken()}&parkingLotId=${parkingLotId}&payType=${payType}&payNo=${payNo}&plateNumber=${plateNumber}&outPassageName=${outPassageName}&updateTimeStart=${updateTimeStart}&updateTimeEnd=${updateTimeEnd}`
      );
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        let remarkColumn = this.findObject(this.option.column, 'remark');
        // let outPassageNameColumn = this.findObject(this.option.column,'outPassageName');
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          // getOutPassage({spaceId:this.form.parkingLotId}).then(res=>{
          //   outPassageNameColumn.dicData = res.data;
          //   th = res.data;
          // })
          getFreeOpenReason({ spaceId: this.form.parkingLotId }).then((res) => {
            remarkColumn.dicData = res.data;
          });
        });
      }
      done();
    },
    searchReset() {
      this.searchForm.updateTimeRange = [this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1,'day'),this.dayjs().format('YYYY-MM-DD 23:59:59'),];
      this.query = {
        updateTimeRange:[this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1,'day'),this.dayjs().format('YYYY-MM-DD 23:59:59')]
      };
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      if (this.vdui.isEmpty(this.parkingLotId)) {
        this.loading = false;
        return;
      }
      this.query.parkingLotId = this.parkingLotId;
      this.query.minMoney = this.minMoney;
      this.query.maxMoney = this.maxMoney;
      page = page || this.page;
      this.loading = true;
      if (!this.query.updateTimeRange) {
        this.query.updateTimeRange = [this.dayjs(this.dayjs().format('YYYY-MM-DD 00:00:00')).subtract(1,'day'),this.dayjs()];
      }
      this.query.updateTimeStart = this.dayjs(this.query.updateTimeRange[0]).format('YYYY-MM-DD HH:mm:ss');
      this.query.updateTimeEnd = this.dayjs(this.query.updateTimeRange[1]).format('YYYY-MM-DD HH:mm:ss');
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          if(this.data[0]){
            this.chargeTotalSum = this.data[0].chargeTotalSum;
            this.chargeAmountSum = this.data[0].chargeAmountSum;
          }else{
            this.chargeTotalSum = 0.00;
            this.chargeAmountSum = 0.00;
          }
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
